import React, { useState } from 'react';
import PartnerReviewReport from './PartnerReviewReport';
import PartnerReplyReport from './PartnerReplyReport';

const PartnerReportManagement = () => {
    const [activeTab, setActiveTab] = useState<'reviews' | 'replies'>('reviews');
    const [loading, setLoading] = useState(false);
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h1 className="">Report Management</h1>
                </div>
            </div>
            {loading ? (
                <>
                    <div className="new-spinner p-absolute">
                        <div>
                            <span className="spinner-border spinner-border-sm custom-spinner-border" />
                        </div>
                        <p className="fs-14 custom-loading-text">Loading</p>
                    </div>
                </>
            ) : (
                <>
                    <div className="card">
                        <div className="employees-table">
                            <nav>
                                <div className="d-flex bd-highlight lt-nav-bar">
                                    <div className="w-100 bd-highlight">
                                        <div className="nav nav-tabs nav-justified" id="nav-tab">
                                            <button
                                                className={`nav-link col-2 fs-16 ${activeTab === 'reviews' ? 'active' : ''}`}
                                                type="button"
                                                onClick={() => setActiveTab('reviews')}
                                            >
                                                Reviews
                                            </button>
                                            <button
                                                className={`nav-link col-2 fs-16 ${
                                                    activeTab === 'replies' ? 'active' : ''
                                                }`}
                                                type="button"
                                                onClick={() => setActiveTab('replies')}
                                            >
                                                Replies
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                            {activeTab === 'reviews' && <PartnerReviewReport />}
                            {activeTab === 'replies' && <PartnerReplyReport />}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PartnerReportManagement;
